<div>
    <div><b>{{text('standingEvaluation.mean.cop.title')}}</b></div>
    <div>{{text('standingEvaluation.longitudinalStandardDeviation')}}
        <b class="d-inline-block">{{longitudinalAverage.format(1)}}</b>
    </div>
    <div>{{text('standingEvaluation.lateralStandardDeviation')}}
        <b class="d-inline-block">{{lateralAverage.format(2)}}</b>
    </div>
</div>
